import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIdNowStepThree = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 174,
	height: 117,
	viewBox: "0 0 174 117",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 64.909C-2.31566e-05 75.3663 8.7374 100.34 27.6375 111.324C46.9358 122.54 63.1158 113.156 85.8738 113.526C103.063 113.805 113.656 118.766 129.896 113.526C152.876 106.111 177.808 93.3989 172.537 71.3301C168.872 55.9827 151.416 56.2319 140.557 44.1782C129.723 32.1539 130.885 19.7399 117.46 10.2384C88.3981 -10.329 52.9552 5.08162 25.8608 27.8504C12.0937 39.4196 2.31567e-05 54.4518 0 64.909Z",
			fill: "#031A6B",
			fillOpacity: .02
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 109.62,
			cy: 81.1293,
			rx: 27,
			ry: 27,
			stroke: "#CAD0E1",
			strokeWidth: .5625,
			strokeLinecap: "round",
			strokeDasharray: "1.5 2.25"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 40.5,
			cy: 65.8521,
			rx: 27,
			ry: 27,
			stroke: "#CAD0E1",
			strokeWidth: .5625,
			strokeLinecap: "round",
			strokeDasharray: "1.5 2.25"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 44.6115,
			cy: 35.5667,
			r: 1.13839,
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 106.326,
			cy: 11.6779,
			r: 1.13839,
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 118.862,
			cy: 64.2944,
			r: 1.13839,
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 35.4509,
			cy: 78.8029,
			r: 1.13839,
			stroke: "#CAD0E1",
			strokeWidth: .375
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 121.888,
			y1: 38.6646,
			x2: 121.888,
			y2: 39.6154,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 121.888,
			y1: 40.4325,
			x2: 121.888,
			y2: 41.3834,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 120.562,
			y1: 40.0575,
			x2: 121.513,
			y2: 40.0575,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 122.33,
			y1: 40.0575,
			x2: 123.281,
			y2: 40.0575,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 124.795,
			y1: 70.6696,
			x2: 124.795,
			y2: 71.6204,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 124.795,
			y1: 72.4374,
			x2: 124.795,
			y2: 73.3883,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 123.469,
			y1: 72.0624,
			x2: 124.42,
			y2: 72.0624,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 125.237,
			y1: 72.0624,
			x2: 126.187,
			y2: 72.0624,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 109.283,
			y: 74.4936,
			width: 20.0761,
			height: 11.083,
			rx: .375,
			transform: "rotate(24.0179 109.283 74.4936)",
			stroke: "#CAD0E1",
			strokeWidth: .75
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M117.267 84.0936L122.942 92.4372C123.059 92.6084 123.292 92.6528 123.463 92.5364C123.635 92.4199 123.679 92.1866 123.563 92.0154L118.094 83.9748L117.267 84.0936ZM115.143 83.1473L114.679 82.4534L105.044 83.7633C104.839 83.7912 104.695 83.9802 104.723 84.1854C104.751 84.3906 104.94 84.5344 105.145 84.5065L115.143 83.1473Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M109.14 75.0557L115.907 84.2894L127.298 83.147",
			stroke: "#CAD0E1",
			strokeWidth: .75,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.2074 44.6646C37.2074 63.2646 51.9574 77.7896 61.2074 82.7271V84.0396C36.0074 69.0396 44.7074 51.5396 52.2074 44.6646Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M53.1449 43.5396C56.5199 41.7896 63.8699 37.6521 66.2699 35.1021C62.5824 35.2271 54.7949 37.0896 53.1449 43.5396Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.9574 50.2896C51.9574 50.6646 57.0074 50.3271 61.2074 45.9771C58.7424 45.1646 53.0415 44.8896 49.9574 50.2896Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47.3324 61.1646C49.3324 60.4771 53.5199 57.8646 54.2699 52.9146C51.4574 52.9771 46.1324 54.7146 47.3324 61.1646Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.9574 70.9146C51.5199 70.1021 54.4574 67.0146 53.7074 61.1646C51.0199 61.8521 46.5074 64.7646 49.9574 70.9146Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M58.2074 79.7271C58.8949 77.7896 59.6699 73.0896 57.2699 69.7896C54.9574 70.9771 51.9074 74.6271 58.2074 79.7271Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.2699 80.8521C52.8324 78.9771 48.3074 74.9271 41.7074 73.7271C43.1449 76.9146 47.6699 82.8021 54.2699 80.8521Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.2074 70.9146C45.1449 68.2896 42.0074 62.7771 37.9574 61.7271C37.5267 64.7896 38.5738 70.9146 46.2074 70.9146Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.5824 60.6021C43.7699 57.3521 43.3574 50.5521 40.2074 49.3521C38.4574 52.1021 36.6824 58.2021 43.5824 60.6021Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M46.2074 49.3521C46.2074 49.3521 50.5199 45.0396 48.0824 38.1021C45.4574 40.5645 41.4074 46.262 46.2074 49.3521Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 120.339,
			y1: 41.7422,
			x2: 117.265,
			y2: 44.8506,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 123.339,
			y1: 73.6172,
			x2: 120.265,
			y2: 76.7256,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 45.7955,
			y1: 102.602,
			x2: 47.9168,
			y2: 104.723,
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 49.773,
			y1: 106.579,
			x2: 51.8944,
			y2: 108.701,
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 46.0607,
			y1: 108.701,
			x2: 48.182,
			y2: 106.58,
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 50.0381,
			y1: 104.723,
			x2: 52.1594,
			y2: 102.602,
			stroke: "#CAD0E1",
			strokeWidth: 1.125,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 119.963,
			y1: 43.2422,
			x2: 114.64,
			y2: 48.6012,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 122.963,
			y1: 75.1172,
			x2: 117.64,
			y2: 80.4762,
			stroke: "#CAD0E1",
			strokeWidth: .375,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50.6139 23.4661C50.6139 23.4661 52.1043 23.2257 52.7389 22.591C53.3735 21.9564 53.6139 20.466 53.6139 20.466C53.6139 20.466 53.8543 21.9564 54.489 22.591C55.1236 23.2257 56.614 23.4661 56.614 23.4661C56.614 23.4661 55.1236 23.7065 54.489 24.3411C53.8543 24.9757 53.6139 26.4661 53.6139 26.4661C53.6139 26.4661 53.3735 24.9757 52.7389 24.3411C52.1043 23.7065 50.6139 23.4661 50.6139 23.4661Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.125 26.1021C115.125 26.1021 116.615 25.8616 117.25 25.227C117.885 24.5924 118.125 23.102 118.125 23.102C118.125 23.102 118.365 24.5924 119 25.227C119.635 25.8616 121.125 26.1021 121.125 26.1021C121.125 26.1021 119.635 26.3425 119 26.9771C118.365 27.6117 118.125 29.1021 118.125 29.1021C118.125 29.1021 117.885 27.6117 117.25 26.9771C116.615 26.3425 115.125 26.1021 115.125 26.1021Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.5 104.852C67.5 104.852 68.9904 104.612 69.625 103.977C70.2597 103.342 70.5001 101.852 70.5001 101.852C70.5001 101.852 70.7405 103.342 71.3751 103.977C72.0097 104.612 73.5001 104.852 73.5001 104.852C73.5001 104.852 72.0097 105.092 71.3751 105.727C70.7405 106.362 70.5001 107.852 70.5001 107.852C70.5001 107.852 70.2597 106.362 69.625 105.727C68.9904 105.092 67.5 104.852 67.5 104.852Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter0_d_2044_1280)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					x: 53,
					y: 35,
					width: 13.5,
					height: 13.5,
					fill: "#A4ACCC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 53,
					y: 54.5,
					width: 13.5,
					height: 13.5,
					fill: "#A4ACCC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 53,
					y: 74,
					width: 13.5,
					height: 13.5,
					fill: "#A4ACCC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.5,
					y: 74,
					width: 13.5,
					height: 13.5,
					fill: "#A4ACCC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.5,
					y: 54.5,
					width: 13.5,
					height: 13.5,
					fill: "#A4ACCC"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 72.5,
					y: 35,
					width: 13.5,
					height: 13.5,
					fill: "#A4ACCC"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 116.75,
					cy: 61.25,
					r: 12.75,
					stroke: "#A4ACCC",
					strokeWidth: 3
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M105.5 35H92V48.5H103.002C103.765 47.6775 104.601 46.9236 105.5 46.2486V35Z",
					fill: "#A4ACCC"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M99.2517 68C98.4433 65.9056 98 63.6296 98 61.25C98 58.8704 98.4433 56.5944 99.2517 54.5L92 54.5V68H99.2517Z",
					fill: "#A4ACCC"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M103.002 74C103.765 74.8225 104.601 75.5764 105.5 76.2514V87.5H92V74H103.002Z",
					fill: "#A4ACCC"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.5 48.5V35C66.5 35 64.7786 41.2214 62 44C59.2214 46.7786 53 48.5 53 48.5H66.5Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86 48.5V35C86 35 84.2786 41.2214 81.5 44C78.7214 46.7786 72.5 48.5 72.5 48.5H86Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92 48.5H103.25L105.5 46.25V35C105.5 35 103.779 41.2214 101 44C98.2214 46.7786 92 48.5 92 48.5Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.4524 65.3594C95.5243 67.0265 92 68.0016 92 68.0016H99.248L98.75 66.5016L98.4524 65.3594Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.5 68V54.5C66.5 54.5 64.7786 60.7214 62 63.5C59.2214 66.2786 53 68 53 68H66.5Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86 68V54.5C86 54.5 84.2786 60.7214 81.5 63.5C78.7214 66.2786 72.5 68 72.5 68H86Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M86 87.5V74C86 74 84.2786 80.2214 81.5 83C78.7214 85.7786 72.5 87.5 72.5 87.5H86Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92 87.4982H105.5V76.2482L104.92 75.8008C104.196 77.8575 102.827 81.1717 101 82.9982C98.2214 85.7769 92 87.4982 92 87.4982Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.5 87.5V74C66.5 74 64.7786 80.2214 62 83C59.2214 85.7786 53 87.5 53 87.5H66.5Z",
			fill: "#818CB5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M92.2667 17.1492L86.4846 26.3999L84.5288 25.1774L89.1505 17.7832L89.0963 17.7493L86.1478 17.7531L87.232 16.0186L90.4283 16.0001L92.2667 17.1492Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30.6683 64.5992C31.144 64.8966 31.5519 65.2625 31.8918 65.6969C32.2347 66.1332 32.4701 66.6342 32.5981 67.2C32.729 67.7676 32.7147 68.4036 32.5551 69.1079C32.4003 69.811 32.0629 70.5821 31.5426 71.4211C31.0514 72.2071 30.524 72.8532 29.9604 73.3594C29.4018 73.8646 28.8238 74.2299 28.2264 74.4553C27.629 74.6808 27.0279 74.7615 26.423 74.6975C25.82 74.6305 25.2324 74.4181 24.6602 74.0605C24.0429 73.6747 23.5722 73.215 23.2482 72.6816C22.926 72.1452 22.7493 71.5804 22.718 70.9872C22.6917 70.3928 22.8103 69.8178 23.0738 69.2622L25.0025 70.4678C24.867 70.8521 24.8614 71.2129 24.9856 71.5502C25.1117 71.8844 25.3524 72.1626 25.7077 72.3847C26.31 72.7612 26.9314 72.7853 27.5721 72.4571C28.2147 72.1258 28.8235 71.5035 29.3987 70.5899L29.3355 70.5504C29.0276 70.7348 28.695 70.8515 28.3378 70.9004C27.9825 70.9463 27.6198 70.9269 27.2498 70.8422C26.8827 70.7594 26.5291 70.6116 26.1888 70.3989C25.6438 70.0583 25.2375 69.6263 24.9698 69.1031C24.7022 68.5798 24.5852 68.0167 24.6187 67.4137C24.6522 66.8107 24.8487 66.2216 25.2082 65.6464C25.593 65.0242 26.0814 64.561 26.6735 64.2569C27.2656 63.9528 27.9063 63.8256 28.5955 63.8753C29.2896 63.9239 29.9805 64.1652 30.6683 64.5992ZM29.7219 66.1435C29.4177 65.9534 29.1015 65.8562 28.7733 65.8521C28.4481 65.8498 28.14 65.9273 27.849 66.0847C27.561 66.2439 27.3244 66.475 27.1392 66.778C26.9491 67.0821 26.8441 67.3976 26.8241 67.7243C26.8091 68.0499 26.8723 68.3575 27.0138 68.6469C27.1602 68.9353 27.384 69.1736 27.6851 69.3618C27.911 69.5029 28.1466 69.5916 28.392 69.6277C28.6375 69.6639 28.8771 69.6524 29.1108 69.5933C29.3495 69.5331 29.5706 69.4305 29.7743 69.2856C29.9779 69.1407 30.1484 68.9583 30.2858 68.7385C30.4654 68.4445 30.5637 68.1332 30.5806 67.8046C30.5976 67.476 30.5332 67.1636 30.3875 66.8673C30.2419 66.5711 30.02 66.3298 29.7219 66.1435Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M110.858 103.82C110.09 104.027 109.371 104.079 108.7 103.976C108.031 103.869 107.461 103.63 106.989 103.256C106.519 102.879 106.197 102.385 106.021 101.774L108.264 101.17C108.347 101.423 108.492 101.627 108.699 101.781C108.908 101.931 109.157 102.023 109.447 102.059C109.736 102.096 110.043 102.07 110.369 101.982C110.709 101.891 110.993 101.75 111.221 101.56C111.449 101.37 111.608 101.148 111.699 100.896C111.789 100.644 111.796 100.379 111.722 100.101C111.646 99.8197 111.5 99.5923 111.284 99.4188C111.071 99.2409 110.802 99.1295 110.477 99.0845C110.156 99.0386 109.796 99.0692 109.399 99.1763L108.416 99.4409L107.976 97.8053L108.958 97.5407C109.294 97.4502 109.575 97.3121 109.801 97.1262C110.03 96.9395 110.189 96.7238 110.278 96.4793C110.365 96.2313 110.372 95.9685 110.297 95.6908C110.226 95.4267 110.1 95.2123 109.92 95.0476C109.742 94.8786 109.524 94.7679 109.268 94.7157C109.014 94.6626 108.738 94.6762 108.44 94.7565C108.138 94.8377 107.877 94.9669 107.656 95.1441C107.435 95.3178 107.275 95.5244 107.178 95.7639C107.08 96.0034 107.063 96.2583 107.124 96.5285L104.99 97.1033C104.837 96.4936 104.866 95.912 105.077 95.3586C105.289 94.8052 105.644 94.3216 106.143 93.9077C106.644 93.4895 107.255 93.1834 107.975 92.9895C108.702 92.7938 109.374 92.7545 109.99 92.8717C110.606 92.9889 111.126 93.2315 111.549 93.5994C111.974 93.963 112.26 94.423 112.406 94.9795C112.568 95.5683 112.517 96.1098 112.253 96.6038C111.992 97.097 111.581 97.4761 111.02 97.7412L111.042 97.8235C111.844 97.7143 112.506 97.8246 113.029 98.1546C113.554 98.4802 113.903 98.9709 114.076 99.6268C114.241 100.226 114.212 100.806 113.988 101.366C113.767 101.926 113.387 102.422 112.849 102.853C112.311 103.285 111.647 103.607 110.858 103.82Z",
			fill: "#CAD0E1"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_2044_1280",
			x: 47,
			y: 35,
			width: 90,
			height: 73.5,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 15 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 3 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.894118 0 0 0 0 0.894118 0 0 0 0 0.92549 0 0 0 0.5 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_2044_1280"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_2044_1280",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgIdNowStepThree);
export { ForwardRef as ReactComponent };
